import React, { Component, createRef } from "react";
// // Editable
import { success, info, error, warning, clear } from "toastr";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Card, CardBody, Container, Label, Row } from "reactstrap";
import validate from "../../common/validation";
import { Formik, Field, Form, ErrorMessage } from "formik";
import moment from "moment/moment";
import { categoriTypes, cubeList, process } from "../StaticData.js";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import {
  addCubes,
  addMachineOperaterStock,
  getCubeBelts,
  getCubesWithProcessId,
  getProcess,
  getUserApi,
  updateCubes,
  updateFillerStock,
  updateMachineOperatorStocks,
} from "api";
import { type } from "@testing-library/user-event/dist/type";
import { withTranslation } from "react-i18next";

class MacOperatorEditVerifyAndAccept extends Component {
  constructor(props) {
    super(props);
    console.log(props);
    this.state = {
      ...this.props,
      validation: "",
      editRowIndex: -1,
      colVal: 0,
      rowVal: 0,
      isSubmit: false,
      flag: null,
      usedCylinder: 0,
      processList: [],
      beltId: "",
      props: props?.location?.query
        ? props?.location?.query
        : { isEdit: 1, data: null },
      category: "",
      processId:
        props?.location?.query?.isEdit == 1
          ? props?.location?.query?.data?.processId
          : props?.location?.query?.data?.cubeBelt.processId,
      machineId:
        props.location.query && props.location.query.data.machineId == null
          ? ""
          : props?.location?.query?.data?.machineId,
      stockList: [],
      JangadList: [],
      userList: [],
      cylinder1:
        props.location.query && props?.location?.query?.isEdit == 1
          ? props?.location?.query?.data.cubeInformations.filter(x => {
              return x.cylinderNo == 1;
            })
          : props?.location?.query?.data.stockMachineOperatorInWards.filter(
              x => {
                return x.cylinderNo == 1;
              }
            ),
      cylinder2:
        props.location.query && props?.location?.query?.isEdit == 1
          ? props?.location?.query?.data.cubeInformations.filter(x => {
              return x.cylinderNo == 2;
            })
          : props?.location?.query?.data.stockMachineOperatorInWards.filter(
              x => {
                return x.cylinderNo == 2;
              }
            ),
      tray: [],
      notEditableRows1:
        props?.location?.query?.isEdit == 1
          ? props?.location?.query?.data.cubeInformations.map(x => x.id)
          : props?.location?.query?.data.stockMachineOperatorInWards.map(
              x => x.id
            ),
      notEditableRows2:
        props?.location?.query?.isEdit == 1
          ? props?.location?.query?.data.cubeInformations.map(x => x.id)
          : props?.location?.query?.data.stockMachineOperatorInWards.map(
              x => x.id
            ),
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }
  setJangadList() {
    this.setState({
      JangadList: this.state.stockList
        .map(x => {
          return { label: x.mainJangadId, value: x.mainJangadId };
        })
        .filter(y => {
          let stockFillerInWardsList = this.state.stockList.filter(
            x => x.mainJangadId == y.value
          )[0].stockFillerInWards;
          let cyclinder1 = this.state.cylinder1.filter(
            a => a.mainJangadId == y.value
          );
          let cyclinder2 = this.state.cylinder2.filter(
            a => a.mainJangadId == y.value
          );
          return stockFillerInWardsList.length ==
            cyclinder1.length + cyclinder2.length
            ? false
            : true;
        }),
    });
  }

  validateTable() {
    for (let i = 0; i < this.state.cylinder1.length; i++) {
      let e = this.state.cylinder1[i];
      if (e.srNo == "") {
        return false;
      }
    }
    return true;
  }

  validateTable1() {
    for (let i = 0; i < this.state.cylinder2.length; i++) {
      let e = this.state.cylinder2[i];
      if (e.srNo == "") {
        return false;
      }
    }
    return true;
  }

  async componentDidMount() {
    this.validateTable();
    this.validateTable1();
    const process = await getProcess();
    if (process && process.data) {
      this.setState({
        processList: process.data,
      });
    }
    const machineOperator = await getUserApi({
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      roleId: "ROLE0000004",
    });
    this.setState({
      userList: machineOperator.data.users,
    });
    if (this.state.props.isEdit == 1) {
      let processId = this.state.props.data.processId;
      let cubeBeltId = this.state.props.data.id;
      const data = await getCubesWithProcessId({
        id: processId,
        cubeBeltId: cubeBeltId,
        fillerId: null,
      });
      this.setState(
        {
          stockList: data.data.fillerStocks,
        },
        () => {
          this.setState(
            {
              JangadList: this.state.stockList.map(x => {
                return { label: x.mainJangadId, value: x.mainJangadId };
              }),
            },
            () => {
              this.setJangadList();
            }
          );
        }
      );
    }
  }

  async getCube() {
    const stock = await getCubesWithProcessId({
      id: this.state.processId,
      cubeBeltId: null,
      fillerId: null,
    });
    this.setState(
      {
        JangadList: stock.data.fillerStocks.map(x => {
          return { label: x.mainJangadId, value: x.mainJangadId };
        }),
        stockList: stock.data.fillerStocks,
      },
      () => {
        this.setJangadList();
      }
    );
  }

  deleteRow(rowIndex, name, row, notEditableRows) {
    this.state[name].splice(rowIndex, 1);
    this.setState(
      {
        [name]: this.state[name].map((x, index) => {
          return {
            ...x,
            id: index + 1,
          };
        }),
        [notEditableRows]: this.state[name].map((x, index) => index + 1),
      },
      () => this.setJangadList()
    );
  }

  async handleSubmit(e, values) {
    e.preventDefault();
    if (this.state.props.isEdit == 1) {
      let temp = {
        remarks: values.remarks,
        nextRemarks: values.nextRemarks,
        cubeBeltId: this.state.props.data.id,
        stockMachineOperatorInWards: this.state.props.data.cubeInformations,
      };
      if (
        Array.isArray(temp.stockMachineOperatorInWards) &&
        temp.stockMachineOperatorInWards.length > 0
      ) {
        const data = await addMachineOperaterStock(temp);
        if (data && data.success == true) {
          this.props.history.goBack();
        }
      } else {
        error("Data is not available");
      }
    } else {
      let temp = {
        machineId: parseInt(values.machineId),
        nextRemarks: values.nextRemarks,
      };
      const data = await updateMachineOperatorStocks({
        id: this.state.props.data.id,
        data: temp,
      });
      if (data && data.success == true) {
        this.props.history.goBack();
      }
    }
  }

  async reject() {
    const data = await updateCubes({
      id: this.state.props.data.id,
      data: {
        machineOperatorStatus: "R",
      },
    });
    if (data && data.success) {
      this.state.history.goBack();
    }
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }
  render() {
    document.title = "filler flow";
    this.columns1 = [
      {
        dataField: "id",
        text: `${this.props.t("ID")}`,
        footer: "",
        hidden: true,
      },
      {
        dataField: "mainJangadId",
        text: `${this.props.t("Jangad Id")}`,
        footer: "Total",
        formatter: (cell, row) => {
          return row.mainJangad.name;
        },
        editable: false,
      },
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No.")}`,
        footer: "",
        editable: false,
        formatter: (cell, row) => {
          return row.stockDataEntryInWard.srNo;
        },
      },
      // {
      //   dataField: "category",
      //   text: `${this.props.t("Category")}`,
      //   footer: "",
      //   editable: false,
      //   formatter: (cell, row) => {
      //     return row.mainJangad.category.name;
      //   },
      // },
      {
        dataField: "shape",
        text: `${this.props.t("Shape")}`,
        footer: "",
        editable: false,
        formatter: (cell, row) => {
          if (this.state.props.isEdit == 1) {
            return row?.stockFillerInWard?.assignGraderToFillerInWard?.stockGraderInWard?.shape?.name || '';
          } else {
            return row?.cubeInformation?.stockFillerInWard?.assignGraderToFillerInWard?.stockGraderInWard?.shape?.name || '';
          }
        },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        footer: "",
        editable: false,
        formatter: (cell, row) => {
          return row.assignGraderToFillerInWard.weight;
        },
      },
    ];

    document.title = "add party";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs
              breadcrumbItem={`${this.props.t("Edit Filling Process (Belt)")}`}
            />
            <Formik
              enableReinitialize={true}
              initialValues={
                this.state.props.isEdit == 1
                  ? {
                      beltId: this.state.props.data.cubeId,
                      processId: this.state.props.data.processId,
                      usedCylinder: this.state.props.data.usedCylinder,
                      machineOperatorId: JSON.parse(
                        localStorage.getItem("authUser")
                      ).name,
                      machineId: this.state.machineId,
                      remarks: this.state.props.data.remarks,
                      nextRemarks: "",
                    }
                  : {
                      beltId: this.state.props.data.cubeBelt.cubeId,
                      processId: this.state.props.data.cubeBelt.processId,
                      usedCylinder: this.state.props.data.cubeBelt.usedCylinder,
                      machineOperatorId: JSON.parse(
                        localStorage.getItem("authUser")
                      ).name,
                      machineId: this.state.machineId,
                      remarks: this.state.props.data.cubeBelt.remarks,
                      nextRemarks: this.state.props.data.nextRemarks,
                    }
              }
              validationSchema={Yup.object().shape({
                beltId: Yup.string().notRequired(),
                processId: Yup.string().required("This Value is Required"),
                usedCylinder: Yup.string().required("This Value is Required"),
                machineOperatorId: Yup.string().nullable().notRequired(),
                remarks: Yup.string().max(512).nullable().notRequired(),
                nextRemarks: Yup.string().max(512).nullable().notRequired(),
              })}
            >
              {({ errors, status, touched, isValid, values, validateForm }) => (
                <Form className="needs-validation">
                  <Card className="px-4">
                    <div className="d-lg-flex d-block justify-content-between pt-3">
                      <div>
                        <h4 className="pb-3 text-black fw-bold">
                          {this.props.t("Edit Filling Process (Belt)")}
                        </h4>
                      </div>
                      {/* <div className="mb-3 row ">
                        <label
                          htmlFor="date"
                          className="col-12 col-sm-2 col-lg-4"
                        >
                          <h5 className="fs-5 fw-bold text-black">Date:</h5>
                        </label>
                        <div className="col-12 col-sm-5 col-lg-6">
                          <input
                            className="border-0 fs-5"
                            type="date"
                            name="date"
                          />
                        </div>
                      </div> */}
                    </div>
                    <div className="mb-3 row">
                      <Label
                        htmlFor="beltId"
                        className="col-lg-2 col-form-label"
                      >
                        <h5 className="text-secondary fw-bold">
                          {this.props.t("Belt Id")}
                        </h5>
                      </Label>
                      <div className="col-lg-10 col-12">
                        <Field
                          className={
                            "form-control fs-5" +
                            (errors.beltId && touched.beltId
                              ? " is-invalid"
                              : "")
                          }
                          readOnly={true}
                          name="beltId"
                          type="text"
                          placeholder="Enter Belt Id"
                        />
                        <ErrorMessage
                          name="beltId"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <Label
                        htmlFor="processId"
                        className="col-lg-2 col-form-label"
                      >
                        <h5 className="text-secondary fw-bold">
                          {this.props.t("Assign Process")}
                        </h5>
                      </Label>
                      <div className="col-lg-10 col-12">
                        <Field
                          className={
                            "form-control form-select fs-5" +
                            (errors.processId && touched.processId
                              ? " is-invalid"
                              : "")
                          }
                          value={this.state.processId}
                          onChange={e => {
                            this.setState(
                              {
                                cylinder1: [],
                                cylinder2: [],
                                notEditableRows1: [],
                                notEditableRows2: [],
                                JangadList: [],
                                stockList: [],
                                processId: e.target.value,
                              },
                              () => this.getCube()
                            );
                          }}
                          disabled={true}
                          name="processId"
                          as="select"
                          defaultValue=""
                        >
                          {this.state.processList?.map(x => (
                            <option key={x.id} value={x.id}>
                              {x.name}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="processId"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <Label
                        htmlFor="machineOperatorId"
                        className="col-md-2 col-form-label"
                      >
                        <h5 className="text-secondary fw-bold">
                          {this.props.t("Machine Operator")}
                        </h5>
                      </Label>
                      <div className="col-md-10 col-12">
                        <Field
                          className={
                            "form-control fs-5" +
                            (errors.machineOperatorId &&
                            touched.machineOperatorId
                              ? " is-invalid"
                              : "")
                          }
                          name="machineOperatorId"
                          disabled={true}
                        ></Field>
                        <ErrorMessage
                          name="machineOperatorId"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    {this.state.props.isEdit == 1 ? (
                      ""
                    ) : (
                      <div className="mb-3 row">
                        <Label
                          htmlFor="machineId"
                          className="col-md-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">Machine</h5>
                        </Label>
                        <div className="col-md-10 col-12">
                          <Field
                            className={
                              "form-control form-select fs-5" +
                              (errors.machineId && touched.machineId
                                ? " is-invalid"
                                : "")
                            }
                            name="machineId"
                            as="select"
                            disabled={
                              this.state.props.isEdit == 3 ? true : false
                            }
                          >
                            <option value="" disabled>
                              select
                            </option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                          </Field>
                          <ErrorMessage
                            name="machineId"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                    )}

                    <div className="mb-3 row">
                      <Label
                        htmlFor="remarks"
                        className="col-md-2 col-form-label"
                      >
                        <h5 className="text-secondary fw-bold">
                          {this.props.t("Filler Notes")}
                        </h5>
                      </Label>
                      <div className="col-md-10">
                        <Field
                          className={
                            "form-control fs-5" +
                            (errors.remarks && touched.remarks
                              ? " is-invalid"
                              : "")
                          }
                          readOnly={true}
                          type="text"
                          name="remarks"
                          as="textarea"
                          rows="5"
                          placeholder="Please Take of HPHT First Priority"
                          disabled={true}
                        />
                        <ErrorMessage
                          name="remarks"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <Label
                        htmlFor="nextRemarks"
                        className="col-md-2 col-form-label"
                      >
                        <h5 className="text-secondary fw-bold">
                          {this.props.t("Boil Man Notes")}
                        </h5>
                      </Label>
                      <div className="col-md-10">
                        <Field
                          className={
                            "form-control fs-5" +
                            (errors.nextRemarks && touched.nextRemarks
                              ? " is-invalid"
                              : "")
                          }
                          readOnly={this.state.props.isEdit == 3 ? true : false}
                          type="text"
                          name="nextRemarks"
                          as="textarea"
                          rows="5"
                          placeholder="Please Take of HPHT First Priority"
                        />
                        <ErrorMessage
                          name="nextRemarks"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    {/* <div className="row pt-3">
                      <div className="col-2">
                        <label htmlFor="rows" className="fs-5 pe-3">
                          Rows
                        </label>
                      </div>
                      <div className="col-4">
                        <input
                          className="form-control"
                          name="rows"
                          type="number" onWheel={(e) => e.target.blur()}
                          value={this.state.rowVal}
                          onChange={e =>
                            this.setState({ rowVal: parseInt(e.target.value) })
                          }
                        />
                      </div>
                      <div className="col-2 text-start text-xxl-center">
                        <label htmlFor="cols" className="fs-5 pe-3">
                          Columns
                        </label>
                      </div>
                      <div className="col-4">
                        <input
                          className="form-control"
                          type="number" onWheel={(e) => e.target.blur()}
                          name="cols"
                          value={this.state.colVal}
                          onChange={e =>
                            this.setState({ colVal: parseInt(e.target.value) })
                          }
                        />
                      </div>
                    </div> */}

                    <div>
                      <table>
                        <tr>
                          {" "}
                          {(() => {
                            let tdArrray = [];
                            for (
                              let j = 0;
                              j < this.state.cylinder1.length;
                              j++
                            ) {
                              tdArrray.push(
                                <td className="p-2">
                                  <div className="d-block text-center">
                                    <div>{j + 1}</div>
                                    <div className="c-bg w-100 h-100 rounded-circle p-4"></div>
                                  </div>
                                </td>
                              );
                            }
                          })()}
                        </tr>
                        <tr>
                          {(() => {
                            let tdArrray = [];
                            for (
                              let j = 0;
                              j < this.state.cylinder2.length;
                              j++
                            ) {
                              tdArrray.push(
                                <td className="p-2">
                                  <div className="d-block text-center">
                                    <div>{j + 1}</div>
                                    <div className="c-bg w-100 h-100 rounded-circle p-4"></div>
                                  </div>
                                </td>
                              );
                            }
                          })()}
                        </tr>
                      </table>
                      {/* <table>
                        {(() => {
                          let trArrray = [];
                          for (
                            let i = 0;
                            i < parseInt(this.state.rowVal);
                            i++
                          ) {
                            trArrray.push(
                              <>
                                <tr>
                                  {(() => {
                                    let tdArrray = [];
                                    for (
                                      let j = 0;
                                      j < parseInt(this.state.colVal);
                                      j++
                                    ) {
                                      tdArrray.push(
                                        <td className="p-2">
                                          <div className="d-block text-center">
                                            <div>{i + j + 1}</div>
                                            <div className="c-bg w-100 h-100 rounded-circle p-4"></div>
                                          </div>
                                        </td>
                                      );
                                    }
                                    return tdArrray;
                                  })()}
                                </tr>
                              </>
                            );
                          }
                          return trArrray;
                        })()}
                      </table> */}
                    </div>

                    <div className="d-lg-flex d-block justify-content-between pt-3">
                      {/* <div>
                        <h4 className="pb-3 text-black fw-bold">
                          {this.props.t("Belt Details")}
                        </h4>
                      </div>
                      <div className="mb-3 row">
                        <div className="col-12 col-sm-5 col-lg-6">
                          <Label
                            htmlFor="usedCylinder"
                            className="col-form-label"
                          >
                            <h5 className="text-secondary fw-bold">
                              {this.props.t("Total Used Cylinder Kit")}
                            </h5>
                          </Label>
                        </div>
                        <div className="col-12 col-sm-5 col-lg-6">
                          <Field
                            className={
                              "form-control fs-5" +
                              (errors.usedCylinder && touched.usedCylinder
                                ? " is-invalid"
                                : "")
                            }
                            name="usedCylinder"
                            type="text"
                            placeholder="Enter Belt Id"
                          ></Field>
                          <ErrorMessage
                            name="usedCylinder"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div> */}
                      {/* <div className="mb-3 row">
                        <div className="col-12 col-sm-5 col-lg-6">
                          <label htmlFor="usedCylinder" className="pt-2">
                            <h5 className="fs-5 fw-bold text-black">
                              {this.props.t("Total Used Cylinder Kit")}
                            </h5>
                          </label>
                        </div>
                        <div className="col-12 col-sm-5 col-lg-6">
                          <input
                            className="form-control fs-5 "
                            type="number" onWheel={(e) => e.target.blur()}
                            name="usedCylinder"
                            min={1}
                          />
                        </div>
                      </div> */}
                    </div>
                    <div className="d-flex justify-content-between pt-5">
                      <h3 className="fw-bold pb-3 text-black">
                        {/* {this.props.t("First Cylinder Kit")} */}
                      </h3>
                    </div>
                    <div className="table-responsive">
                      <BootstrapTable
                        keyField="id"
                        classes="foo"
                        headerClasses="background-light fs-5"
                        footerClasses="background-light fs-5"
                        data={this.state.cylinder1}
                        columns={this.columns1}
                        cellEdit={cellEditFactory({
                          mode: "click",
                          blurToSave: true,
                          afterSaveCell: () => {
                            this.setState({
                              cylinder1: [...this.state.cylinder1],
                            });
                          },
                          // nonEditableRows: () => this.state.notEditableRows1,
                        })}
                      />
                    </div>
                    <div className="col-md-12 text-center text-md-end my-4 pe-lg-3">
                      {this.state.props.isEdit == 1 && (
                        <>
                          <Button
                            color="white"
                            className="fs-4 border-0 text-primary me-0 me-md-5 fw-bold"
                            type="submit"
                            onClick={async () => {
                              await validateForm()
                                .then(data => {
                                  if (Object.keys(data).length == 0) {
                                    this.handleSubmit(event, values);
                                  }
                                })
                                .catch(err => console.log("err =>", err));
                            }}
                          >
                            Accept
                          </Button>
                          <Button
                            color="primary"
                            onClick={() => this.reject(event, values)}
                            className="fs-4 px-5"
                          >
                            Reject
                          </Button>
                        </>
                      )}
                      {this.state.props.isEdit == 2 && (
                        <>
                          <Button
                            color="primary"
                            className="fs-4 px-5"
                            type="submit"
                            onClick={async () => {
                              await validateForm()
                                .then(data => {
                                  if (Object.keys(data).length == 0) {
                                    this.handleSubmit(event, values);
                                  }
                                })
                                .catch(err => console.log("err =>", err));
                            }}
                          >
                            Update
                          </Button>
                        </>
                      )}
                      {this.state.props.isEdit == 3 && (
                        <Button
                          color="primary"
                          onClick={() => {
                            this.props.history.goBack();
                          }}
                          className="fs-4 px-5"
                        >
                          Back
                        </Button>
                      )}
                    </div>
                    {/* {this.state.props.isEdit == 1 && (
                      <>
                        <div className="col-md-12 text-end mb-4">
                          <Button
                            color="primary"
                            type="submit"
                            className="fs-4 px-5"
                            onClick={async () => {
                              this.setState({ isSubmit: true }, async () => {
                                if (
                                  this.validateTable() &&
                                  this.validateTable1()
                                ) {
                                  await validateForm()
                                    .then(data => {
                                      if (Object.keys(data).length == 0) {
                                        this.handleSubmit(event, values);
                                      }
                                    })
                                    .catch(err => console.log("err =>", err));
                                }
                              });
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </>
                    )}
                    {this.state.props.isEdit != 1 && (
                      <>
                        <div className="col-md-12 text-end mb-4">
                          <Button
                            color="primary"
                            onClick={() => {
                              validateForm()
                                .then(data => {
                                  if (Object.keys(data).length == 0) {
                                    this.handleSubmit(event, values);
                                  }
                                })
                                .catch(err => console.log(err));
                            }}
                            className="fs-4 px-5"
                          >
                            Update
                          </Button>
                        </div>
                      </>
                    )} */}
                  </Card>
                </Form>
              )}
            </Formik>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(MacOperatorEditVerifyAndAccept);
